import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";

const ChangePasswordModal = ({ isOpen, ...props }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(isOpen); // hiển thị khi mount, hoặc đổi theo state thật

    useEffect(() => {
      setOpen(isOpen)
    }, [isOpen]);
  

  const handleOk = () => {
    setOpen(false);
    navigate("/mat-khau"); // chuyển trang nội bộ, không reload
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      title="Yêu cầu thay đổi mật khẩu"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Đổi mật khẩu"
      cancelText="Để sau"
      centered
    >
      <p>
        Mật khẩu của bạn đã hết hạn hoặc cần được thay đổi để đảm bảo an toàn.
      </p>
      <p>Vui lòng cập nhật mật khẩu mới để tiếp tục sử dụng hệ thống.</p>
    </Modal>
  );
};

export default ChangePasswordModal;
